// Import the functions you need from the SDKs you need
import { env } from '@/lib/env';
import { initializeApp } from 'firebase/app';
import { GoogleAuthProvider, connectAuthEmulator, getAuth } from 'firebase/auth';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: 'AIzaSyBZ3emZSgwS4XTAQrnpvpeNWDZW--R-DA0',
  authDomain: 'h2o-delivery-app.firebaseapp.com',
  projectId: 'h2o-delivery-app',
  storageBucket: 'h2o-delivery-app.appspot.com',
  messagingSenderId: '935589581631',
  appId: '1:935589581631:web:ed4e1ddeacaee64ceb798a'
};

// Initialize Firebase
export const firebaseInstance = initializeApp(firebaseConfig);
export const auth = getAuth();

// Test-only: point Firebase Auth at the local emulator instead of real Google sign-in.
// Never set outside a local/CI test run — see AGENTS.md § Verification commands for how this is used.
if (env.VITE_USE_FIREBASE_AUTH_EMULATOR === '1') {
  connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
}

export const provider = new GoogleAuthProvider();
